"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCarcassReturnStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useCarcassReturnStore = (0, pinia_1.defineStore)('carcassReturnStore', {
    state: () => ({
        carcasses: [],
        carcassFiles: [],
        loading: false,
    }),
    actions: {
        getCarcassFiles(router, params) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_get_carcass_files_api',
                    query: {
                        ...params
                    }
                }).href)
                    .then(response => {
                    let items = [];
                    if (Array.isArray(response)) {
                        response.forEach(element => {
                            items.push(element);
                        });
                    }
                    this.carcassFiles = items;
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        },
        getCarcasses(router, params) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_carcass_api_get',
                    query: {
                        ...params
                    }
                }).href)
                    .then(response => {
                    let items = [];
                    if (Array.isArray(response)) {
                        response.forEach(element => {
                            items.push(element);
                        });
                    }
                    this.carcasses = items;
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        },
        createCarcass(router, carcassReturnRequest) {
            let options = { body: JSON.stringify(carcassReturnRequest), method: 'POST' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_carcass_api' }).href, options).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        sendCarcassCreatedEmail(router, payload) {
            let options = { body: JSON.stringify(payload), method: 'POST' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'send_carcass_created_email_api' }).href, options)
                    .then(response => {
                    if (response.status !== 'success') {
                        throw Error(response.error);
                    }
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        },
        sendCarcassFileUploadEmail(router, payload) {
            let options = { body: JSON.stringify(payload), method: 'POST' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'send_carcass_file_upload_email_api' }).href, options)
                    .then(response => {
                    if (response.status !== 'success') {
                        throw Error(response.error);
                    }
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        },
        saveCarcassFile(router, formData) {
            this.loading = true;
            const options = { method: 'POST', body: formData };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_carcass_files_api' }).href, options)
                    .then(response => {
                    this.loading = false;
                    resolve(response);
                })
                    .catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        deleteCarcassFiles(router, carcassFileId) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({
                    name: 'admin_carcass_files_api',
                    params: { id: carcassFileId }
                }).href, { method: 'DELETE' })
                    .then(() => {
                    this.loading = false;
                    resolve();
                })
                    .catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        reset() {
            this.carcasses = [];
            this.carcassFiles = [];
            this.loading = false;
        },
    },
});
